<template>
  <div class="flowList">
    <el-steps
      class="stepsWrap"
      direction="vertical"
      :active="stepsActive"
      step="100px"
    >
      <el-step title="" v-for="(fitem, findex) in flowListData" :key="findex">
        <div slot="icon">
          <template
            v-if="
              (fitem.person_type < 4 || fitem.employees.length == 1) &&
              fitem.employees.length
            "
          > 
          <div class="relative">
            <el-image
              v-if="fitem.employees[0] && fitem.employees[0].picture"
              class="picture_img"
              :src="fitem.employees[0].picture"
              fit="cover"
            ></el-image>
            <div class="picture" v-else>
              {{
                fitem.employees[0] && fitem.employees[0].name
                  ? fitem.employees[0].name.slice(-1)
                  : ""
              }}
            </div>
            <img
              v-if="fitem.employees&&fitem.employees[0]&&fitem.employees[0].is_read"
              src="@/assets/img/isRead.png"
              class="img-son"
              alt=""
              />
          </div>
          </template>
          <div v-else>
            <el-image
              class="picture_img"
              :src="require('@/assets/img/mp@2x.png')"
              fit="cover"
            ></el-image>
          </div>
        </div>
        <div slot="title">
          <div class="person_type">
            <div v-if="fitem.person_type == 0">
              <span
                style="max-width: 147px"
                v-if="`,${dataInfo.creator.id},` == fitem.employee_ids"
                >【发起人】</span
              >
              <span v-else></span>
            </div>
            <div v-else style="max-width: 147px">
              【{{
                toStr(
                  {
                    1: "主管",
                    2: "上级直属主管",
                    3:
                      (fitem.type == 4 ? "转交" : "") +
                      (!!fitem.employee_id_alias
                        ? fitem.employee_id_alias
                        : "审批人"),
                    4:
                      fitem.type == 1
                        ? fitem.processor || fitem.flow_status == 2
                          ? "或签人"
                          : `${fitem.employees.length == 1 ? "1" : "多"}人或签`
                        : "抄送或签人",
                    5:
                      fitem.flow_status == 2
                        ? "会签人"
                        : `${fitem.employees.length == 1 ? "1" : "多"}人会签`,
                    6: !!fitem.employee_id_alias
                      ? fitem.employee_id_alias
                      : `${
                          fitem.turn_over_employee_id > 0 &&
                          fitem.employees.length == 1
                            ? "转交"
                            : ""
                        }办理人`,
                    7: "抄送",
                    9: "部门负责人",
                  },
                  fitem.person_type
                )
              }}】
            </div>
          </div>
          <div v-if="fitem.employees.length > 1 && fitem.flow_status == 3">
            <div style="margin-left: 22px; margin-bottom: 15px">
              <span class="n_t">{{ fitem.update_time }} 已撤销</span>
            </div>
          </div>
          <div
            class="emp_time"
            v-if="fitem.employees.length > 1 && fitem.flow_status == 2"
          >
            <span class="time">{{ fitem.update_time }}</span>
            <span
              class="mar_10"
              :class="'type' + fitem.type"
              v-if="fitem.deal_status == 0"
              >{{
                toStr(
                  {
                    1: "待审核",
                    2: "抄送",
                    3: "评论",
                    4: "转交",
                  },
                  fitem.type
                )
              }}</span
            >
            <span
              class="mar_10"
              v-if="fitem.deal_status != 0"
              :class="'deal_status' + fitem.deal_status"
              >{{
                toStr(
                  {
                    1: fitem.person_type == 6 ? "办理" : "同意",
                    2: "拒绝",
                    3: "退回",
                    4: "转交",
                  },
                  fitem.deal_status
                )
              }}</span
            >
          </div>
          <div class="emp_line">
            <div
              class="empitem"
              :class="{
                flex_1: fitem.employees.length == 1,
              }"
              v-for="(citem, cindex) in fitem.employees"
              :key="cindex"
            >
              <div v-if="fitem.employees.length == 1" class="flex_1">
                <div class="c_d">
                  <div class="flex">
                    <span class="citemname">{{ citem.name }}</span>
                    <span class="c_title" v-if="fitem.employees.length == 1"
                      >【{{ citem.title }}】</span
                    ><span class="lz" v-if="citem.status == 2">已离职</span>
                    <div
                      class="me"
                      v-show="citem.is_self == 1 && fitem.employees.length == 1"
                    >
                      我
                    </div>
                  </div>
                  <div
                    v-if="fitem.flow_status == 3 && fitem.employees.length == 1"
                  >
                    <div style="margin-left: 22px; margin-bottom: 15px">
                      <span class="n_t">{{ fitem.update_time }} 已撤销</span>
                    </div>
                  </div>
                  <div v-if="fitem.flow_status == 2">
                    <span class="time">{{ fitem.update_time }}</span>
                    <span
                      class="mar_10"
                      :class="'type' + fitem.type"
                      v-if="fitem.deal_status == 0"
                      >{{
                        toStr(
                          {
                            1: "待审核",
                            2: "抄送",
                            3: "评论",
                            4: "转交",
                          },
                          fitem.type
                        )
                      }}</span
                    >
                    <span
                      class="mar_10"
                      v-if="fitem.deal_status != 0"
                      :class="'deal_status' + fitem.deal_status"
                      >{{
                        toStr(
                          {
                            1: fitem.person_type == 6 ? "办理" : "同意",
                            2: "拒绝",
                            3: "退回",
                            4: "转交",
                          },
                          fitem.deal_status
                        )
                      }}</span
                    >
                  </div>
                </div>
              </div>

              <div
                v-if="fitem.employees.length > 1 && citem.is_processed != 1"
                class="w80 flex"
              >
                <div class="relative" v-if="citem.is_processed != 1">
                  <el-image
                    v-if="!!citem.picture"
                    class="picture_img forPicPos"
                    :src="citem.picture"
                    fit="cover"
                  >
                  </el-image>
                  <div class="picture forPicPos" v-else>
                    {{ citem.name ? citem.name.slice(-1) : "" }}
                  </div>
                  <img v-if="citem.is_read" src="@/assets/img/isRead.png" class="img-son" alt=""/>
                </div>
                <div class="c_d">
                  <div class="flex">
                    <span class="citemname">{{ citem.name }}</span>
                    <span
                      v-if="fitem.turn_over_employee_id == citem.id"
                      style="font-size: 12px"
                      >(转交人)</span
                    >
                    <span class="lz" v-if="citem.status == 2">已离职</span>
                  </div>
                </div>
              </div>
              <div
                class="empitem4"
                v-if="
                  fitem.person_type == 4 &&
                  cindex != fitem.employees.length - 1 &&
                  fitem.type != 2
                "
              >
                或
              </div>
            </div>
          </div>
        </div>
        <!-- type 处理类型：1-审核；2-抄送；3-评论；4-转交 -->
        <!-- "deal_status": 0, //处理状态：1-同意；2-拒绝；3-退回；4-转交； -->
        <!-- "flow_status": 2, //流程状态：0-未开始；1-待处理；2-已处理； -->
        <div slot="description" v-if="fitem.flow_status == 2">
          <div style="margin-left: 22px; margin-bottom: 15px">
            <div
              class="comment"
              style="background: #eee; padding: 5px 10px; border-radius: 4px"
              v-if="
                fitem.comment ||
                (fitem.picture_arr && fitem.picture_arr.length > 0) ||
                (fitem.file_arr && fitem.file_arr.length > 0) ||
                (dataInfo.extra_data && dataInfo.extra_data.expense && fitem.is_expense == 1)
              "
            >
              <div>
                <!-- <span>{{getAite(fitem)}}</span> -->
                <span>{{ fitem.comment }}</span>
              </div>
              <div v-if="fitem.picture_arr && fitem.picture_arr.length > 0">
                <span class="n_t">图片：</span>
                <span @click="view_img(fitem.picture_arr)" class="simg_num"
                  >{{ fitem.picture_arr.length }}张</span
                >
              </div>
              <div
                v-if="fitem.file_arr && fitem.file_arr.length > 0"
                style="display: flex; flex: 1"
              >
                <span class="n_t">附件：</span>
                <div style="flex: 1">
                  <div
                    class="file_name"
                    v-for="(f, i) in fitem.file_arr"
                    :key="i"
                  >
                    <!-- <div>{{ i + 1 }}: {{ f.name }}</div> -->
                    <el-link
                      type="primary"
                      target="_blank"
                      @click="handlePreview(f)"
                      >{{ i + 1 }}: {{ f.name }}</el-link
                    >
                    <div>
                      <el-button
                        size="mini"
                        type="text"
                        @click="download(f.file, f.name)"
                        >下载</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="dataInfo.extra_data && dataInfo.extra_data.expense && fitem.is_expense == 1">
                <span>可报销金额: {{getFeeTotal()}}元;</span>
                <span v-if="dataInfo.extra_data.expense.payAmount">支付金额: {{dataInfo.extra_data.expense.payAmount}}元</span>
              </div>
            </div>
            <el-table size="mini" :data="expenseData ? expenseData.expenseList : []" border  v-if="fitem.is_expense == 1 && expenseData">
               <el-table-column align="center" prop="feeName" label="费用类型">
               </el-table-column>
               <el-table-column align="center" prop="happenDate" label="发生日期">
               </el-table-column>
               <el-table-column align="center" prop="money" label="金额">
               </el-table-column>
               <el-table-column align="center" prop="amount" label="可报销金额/元">
               </el-table-column>
            </el-table>
          </div>
        </div>
      </el-step>
    </el-steps>
    <el-image-viewer
      v-show="showViewer"
      :on-close="closeViewer"
      :url-list="previewImages"
    />

    <!-- 预览文件 -->
    <VueOfficeView
      ref="fileView"
      :fileType="fileType"
      :fileUrl="fileUrl"
      :fileName="fileName"
    ></VueOfficeView>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import VueOfficeView from "@/components/VueOfficeView.vue";
import { mixinPreview } from "@/mixins/filepreview.js";
import { preciseAdd } from "@/util/util";
export default {
  name: "FlowList",
  mixins: [mixinPreview],
  components: { ElImageViewer, VueOfficeView },
  props: {
    flow_list: { type: Array, default: () => [] },
    dataInfo: { type: Object, default: () => {} },
    stepsActive: { type: Number, default: 1 },
  },
  data() {
    return {
      showViewer: false,
      previewImages: [],
    };
  },
  computed: {
    // 规范化流程数据，避免接口未返回 employees/picture_arr/file_arr 等字段时渲染报错
    flowListData() {
      return (this.flow_list || []).map((item) => ({
        ...item,
        employees: Array.isArray(item.employees) ? item.employees : [],
        picture_arr: Array.isArray(item.picture_arr) ? item.picture_arr : [],
        file_arr: Array.isArray(item.file_arr) ? item.file_arr : [],
      }));
    },
    // 报销相关数据（可能不存在）
    expenseData() {
      const expense =
        this.dataInfo &&
        this.dataInfo.extra_data &&
        this.dataInfo.extra_data.expense;
      if (expense && Array.isArray(expense.expenseList)) {
        return expense;
      }
      return null;
    },
  },
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
    toStr(data, key) {
      return data[key];
    },
    view_img(view_img) {
      this.showViewer = true;
      this.previewImages = view_img;
    },
    download(urls, name) {
      const option = {
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
      if (window?.fetch) {
        fetch(urls, option)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            a.click();
          });
      } else {
        const a = document.createElement("a");
        a.href = urls;
        a.target = "_blank";
        a.download = name;
        a.click();
      }
    },
    getAite(fitem) {
      if(fitem && fitem.at_employees && fitem.at_employees.length){
        let str = ''
        fitem.at_employees.forEach(e => {
          str += `@${e.name} `
        })
        return str + '\n'
      }else {
        return ''
      }
    },
    getFeeTotal() {
      if(!this.expenseData || !this.expenseData.expenseList.length){
        return ''
      }
      let total = 0;
      for (let i = 0; i < this.expenseData.expenseList.length; i++) {
        total = preciseAdd(total, this.expenseData.expenseList[i].amount * 1);
      }
      return total || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex_1 {
  flex: 1;
}
.mb20 {
  margin-bottom: 20px;
}
.relative {
  position: relative;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.num {
  color: #999;
  margin: 0 0 0 3px;
}
.selStatus {
  display: flex;
  margin-top: 10px;
  padding: 0 20px;
  .item {
    margin: 0 30px 0 0;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .item:hover {
    border-bottom: solid 2px #409eff;
    color: #409eff !important;
    .num {
      color: #409eff !important;
    }
  }
  .active {
    border-bottom: solid 2px #409eff;
    color: #409eff !important;
    font-weight: bold;
    .num {
      color: #409eff !important;
      font-weight: bold;
    }
  }
}
.tableWrap {
  padding: 0 20px;
  margin-top: 20px;
  flex: 1;
  overflow-y: scroll;

  .list {
    border: solid 1px #eee;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .list:hover {
    border: solid 1px #0476fc;
  }
  .active {
    background: #f2f8ff;
    border: solid 1px #0476fc;
  }
  .info {
    display: flex;
    display: flex;
    flex-wrap: wrap;

    div {
      width: 50%;
      width: 50%;
      margin-top: 15px;
      display: flex;
    }
    .label {
      color: #999;
    }
    .value {
      display: inline-block;
      max-width: 190px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.type1 {
  color: #ff7e00;
}
.type2 {
  color: #ff7e00;
}
.type3 {
  color: #ff7e00;
}
.type3 {
  color: #ff7e00;
}
.deal_status1 {
  color: #67c23a;
}
.deal_status2 {
  color: #ff2c09;
}
.deal_status3 {
  color: #ff7e00;
}
.deal_status4 {
  color: #ff7e00;
}

// 右边
.right-wrap {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
::v-deep .el-step.is-vertical .el-step__head {
  width: 36px;
}
::v-deep .el-step.is-vertical .el-step__line {
  left: 18px;
}
.flowList {
  // height: 500px;
  margin-left: 160px;
  margin-top: 20px;

  .person_type {
    position: absolute;
    left: -160px;
    background: #fff2e5;
    color: #ff7e00;
    font-size: 14px;
  }
}
.stepsWrap {
  .type1 {
    font-size: 14px;
  }
  .picture {
    width: 36px;
    height: 36px;
    line-height: 36px;
    background: #0476fc;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    border-radius: 50%;
    text-align: center;
  }
  .picture_img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: block;
  }
  .forPicPos{
    position: relative;
  }
  .img-son{
    position: absolute;
    width: 16px;
    height: 16px;
    bottom: 0px;
    right:0px
  }
  .emp_line {
    font-size: 14px;
    display: flex;
  }
  .empitem {
    display: flex;
    font-size: 14px;
  }
  .citemname {
    color: #000;
  }
  .c_title {
    color: #000;
  }
}
.stepsWrap ::v-deep .el-step__icon {
  width: 36px;
  height: 36px;
}
::v-deep .el-step {
  min-height: 80px;
}
::v-deep .el-step__icon.is-text {
  border: none;
}
::v-deep .el-step__head {
  width: 36px;
  opacity: 0.6;
}
::v-deep .el-step__main {
  opacity: 0.6;
}
::v-deep .el-step.is-vertical .el-step__line {
  left: 18px;
}
::v-deep .el-step__line {
  background-color: #e0eefe;
}
::v-deep .el-step__title.is-process {
  font-weight: 400;
  color: #c0c4cc;
}
::v-deep .el-step.is-vertical .el-step__line {
  width: 3px;
}
</style>

<style scoped>
::v-deep .is-bordered-label {
  text-align: center !important;
}
.index_footerWrap {
  padding: 10px 20px 10px;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
  z-index: 2;
  background: #fff;
}
.empitem4 {
  font-size: 14px;
}
.simg_num {
  color: #0476fc;
  cursor: pointer;
  text-decoration-line: underline;
}
.file_name {
  display: flex;
  justify-content: space-between;
  flex: 1;
}
.c_title {
  font-size: 14px;
}
.c_d {
  display: flex;
  justify-content: space-between;
  flex: 1;
}
.me {
  width: 40px;
  height: 28px;
  background: #e5f1ff;
  border-radius: 4px;
  font-size: 16px;
  color: #0476fc;
  line-height: 28px;
  margin: 0 0 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.w80 {
  min-width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tb {
  padding: 10px 0 0;
  border-top: 1px solid #e5e5e5;
  margin: 10px 0 0;
  align-items: center;
}
.ta {
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
}
.tan {
  background: #0476fc;
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.tbl {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666666;
}
.tbl1 {
  color: #999999;
  margin: 0 10px;
}
.tbr {
  font-size: 16px;
  color: #ff2c09;
}
.tbr1 {
  color: #1ec00d;
  font-size: 16px;
}
.tbr2 {
  color: #ff7e00;
  font-size: 16px;
}
.tat {
  margin: 0 10px 0 0;
}
.num1 {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #f4514a;
  font-size: 14px;
  color: #f4514a;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 3px;
}
.comment {
  margin: 5px 0 0;
}
.deal_status1 {
  color: #1ec00d;
}
.deal_status2 {
  color: #ff3d27;
}
.emp_time {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
}
.time {
  color: rgb(153, 153, 153);
}
.mar_10 {
  margin: 0 0 0 10px;
}
::v-deep .el-step__description {
  padding-right: 0;
}
::v-deep .is-finish.el-step__head {
  width: 36px;
  opacity: 1;
}
::v-deep .is-finish + .el-step__main {
  opacity: 1;
}
::v-deep .is-finish .person_type {
  opacity: 1;
}
::v-deep .is-finish .n_t {
  color: #999;
}
.lz {
  color: #ff2c09;
  margin: 0 0 0 5px;
}
.relative {
  position: relative;
}
.img-son {
  position: absolute;
  width: 16px;
  height: 16px;
  bottom: 0px;
  right: 0px;
}
</style>